import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";

function NormalizeDoubleSlash() {
  const { pathname, search } = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    if (pathname.startsWith("//")) {
      const fixed = pathname.replace(/^\/+/, "/");
      navigate(fixed + search, { replace: true });
    }
  }, [pathname, search, navigate]);

  return null;
}

export default NormalizeDoubleSlash;